module.exports = "/images/clock.svg?d2b00323b2287bc12b23b9aa0d50144e";